import { useState, useEffect } from 'react';
import { doc, onSnapshot } from "firebase/firestore";
import { db } from '../firebaseUtils.js';
import { DEFAULT_CONFIG } from '../config/initialData.js';

/**
 * useConfig Hook
 * Fetches global system configurations from Firestore with real-time updates.
 * Falls back to local constants if database is unavailable.
 */
export const useConfig = () => {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Listen to the single metadata document
    const configRef = doc(db, "system_config", "metadata");
    
    const unsubscribe = onSnapshot(configRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        // Merge with defaults to ensure any missing fields don't break the UI
        setConfig({ ...DEFAULT_CONFIG, ...data });
      } else {
        console.warn("System config document not found. Using defaults.");
        setConfig(DEFAULT_CONFIG);
      }
      setLoading(false);
    }, (error) => {
      console.error("Error fetching system config:", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return { config, loading };
};
